import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { DateRangePicker } from "rsuite";
import {
    SBADropDown,
    SBAMultiSelect,
    SBAComboBox,
    SBAMultiSelectCheck,
    SBAMultiColumnComboBox,
} from "../../UiComponents/SBADropDown";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useLocation } from 'react-router-dom';
import "ag-grid-enterprise";
import download from '../../../Images/download.svg';
import { useDispatch, useSelector } from "react-redux";
import {
    getActivitiesDetails,
    getCategory,
    getActivityType,
    getActivityEntityType,
} from "../../actions/investmentAction";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import moment from "moment";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { getMultipleDocs } from "../../actions/assetDocumentsActions";
import { getAssetNoteDetails } from "../../actions/assetNotestabAction";
import "./Library.css";
import { TopBar } from "../../shared/topBar/TopBar";
import { getActivityEntities } from "../../actions/investmentAction";
import { DownloadDocument, DownloadMultiDocument, deleteActivity, getCustomSettings, getUserPageAccess, updateCustomSettings } from "../../../config/apiConfig";
import { getAllUsers } from "../../actions/UserAction";
import { Splitter } from "@progress/kendo-react-layout";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { Modal } from "react-bootstrap";
import { UrlPath } from "../../../config/routeConfig";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import { Unauthorized } from "../../shared/ErrorPage/ErrorPage";

export const Investment = () => {
    const dispatch = useDispatch();
    const gridRef = useRef();

    const history = useNavigate();
    const locationData = useLocation();
    const Level = [{ BreadCrumb: "Documents > Investment", Routes: "/Documents" }];
    const Gstate = useSelector((state) => state) || {};
    const activities = useSelector(state => state.activitityDetails.activitityDetails) || [];
    const Category = useSelector((state) => state.Category.Category) || [];
    const ActivityType = useSelector((state) => state.ActivityType.ActivityType) || [];
    const ActivityentityType = useSelector((state) => state.ActivityentityType.ActivityentityType) || [];
    const activityEntities = useSelector((state) => state.ActivityEntity.Activityentity) || [];
    const activitesGridLoading = useSelector((state) => state.activitityDetails.isLoading);
    const users = useSelector((state) => state.Users.Users);
    const [investmentAccess,setInvestmentAccess]=useState(false);
  
    const [investmentData,setInvestmentData]=useState(activities);
    const [dataLoading,setDataLoading]=useState(false);
    const [accessLoading,setAccessLoading]=useState(true);
    useEffect(()=>{
        setAccessLoading(true);
        sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestmentAccess` }).then(res=>{setInvestmentAccess(res);setAccessLoading(false);}).catch(()=>{setAccessLoading(false)});
    },[])
    useEffect(()=>{
        setInvestmentData(activities)
    },[activities]);
    // useEffect(()=>{setDataLoading(activities)},[activitesGridLoading]);

    // const EntityTypeIS={
    //   "ActivityEntityTypeId": 1,
    //   "ActivityEntityType": "Asset",
    //   "ActivityTypeId": 0,
    //   "ActivityType": null,
    //   "ActivitySubTypeId": 0,
    //   "ActivitySubType": null
    // };
    // const ActivityTypeIS = {
    //   "ActivityEntityTypeId": 0,
    //   "ActivityEntityType": null,
    //   "ActivityTypeId": 2,
    //   "ActivityType": "Document",
    //   "ActivitySubTypeId": 0,
    //   "ActivitySubType": null
    // }
    
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const [EntityTypeIds, setEntityTypeIds] = useState(locationData.state !== null ? locationData.state.Type === null || [] ? ActivityentityType : locationData.state.Type : ActivityentityType);
    const Id = [locationData.state !== null ? locationData.state.Names === null ? "" : locationData.state.Names : ""];
    const [EntityId, setEntityId] = useState(Id?.map(
        (EntityTypes) => EntityTypes?.EntityId)
    );
    const [ActivityTypeIds, setActivityTypeIds] = useState(locationData?.state?.Activity  ? locationData.state.Activity  : ActivityType);

    const [StartDate, setStartDate] = useState(
        locationData.state !== null &&
            locationData.state.StartDate !== null &&
            locationData.state.StartDate !== undefined
            ? locationData.state.StartDate
            : oneMonthAgo
    );

    const [EndDate, setEndDate] = useState(
        locationData.state !== null &&
            locationData.state.EndDate !== null &&
            locationData.state.EndDate !== undefined
            ? locationData.state.EndDate
            : new Date()
    );
    const [dateRange, setDateRange] = useState([new Date(StartDate), new Date(EndDate)]);
    const [ActivitySubTypeIds, setActivitySubTypeIds] = useState(locationData.state !== null ? locationData.state.Category === null ? Category : locationData.state.Category : Category);
    const [Subject, setSubject] = useState(
        locationData.state !== null
            ? locationData.state.Subject === null
                ? null
                : locationData.state.Subject
            : null
    );
    // const [Subject, setSubject] = useState(null);
    // const [Subject, setSubject] = useState(locationData.Subject !== null ? locationData.state.Subject === null || "" ? Subject : locationData.state.Subject : Subject);
    const [DocumentCount, setDocumentCount] = useState(0);
    const [selectedEntity, setSelectedEntity] = useState(locationData.state !== null ? locationData.state.Names === null ? "" : locationData.state.Names : "");
    const [UserId, SetUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [render, setRender] = useState(0);
    const [selectedUser, setSelectedUser] = useState(locationData.state !== null ? locationData.state.Creator === null ? { UserId: "-1", Fullname: "Please Select" } : locationData.state.Creator : { UserId: "-1", Fullname: "Please Select" });
    const [typeselected, setTypeSelected] = React.useState({ value: ActivityentityType, allSelected: true });
    const [activityselected, setActivitySelected] = React.useState({ value: ActivityType, allSelected: true });
    const [categoryselected, setCategorySelected] = React.useState({ value: Category, allSelected: true });
    const [selectedRowDocuList, setSelectedRowDocuList] = useState([]);
    const [idToDelete, setIdToDelete] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showPreview, setShowPreview] = useState();
    const isEditable = Gstate.authorizationData.isEditable;
    const Documents = Gstate.mutipleDocuments.mutipleDocuments || [];
    const DocumentsLoading = Gstate.mutipleDocuments.multipleDocuLoading;
    const documentListRef = useRef();
    const [gridApi, setGridApi] = useState();
    const initiateDetailsdelete = (e) => {
        if (e.data) {
            const ActivityID = e.data.ActivityId;
            setIdToDelete(ActivityID);
            setShowModal(true);
        }
    };
    const onEditButtonClick = (e) => {
        const avtivityid = e.data.ActivityId;
        history(`${UrlPath.DocumentsInvestmentEdit}${e.data.ActivityId}`,
            {
                state:
                {
                    Type: EntityTypeIds,
                    Names: selectedEntity,
                    Activity: ActivityTypeIds,
                    Category: ActivitySubTypeIds,
                    Subject: Subject,
                    Creator: selectedUser,
                    StartDate: StartDate,
                    EndDate: EndDate
                }
            });

    };
    const gridValueFormatter = (params) => {
        return <input type='checkbox' checked={params.value} />;
    };
    const checkBoxFormatter = (params) => {
        return <input type='checkbox' checked={params.value === true} disabled />;
    };
    const valuformaterapply = (params) => {
        return moment(params.value).format("MM/DD/YYYY");
    }
    const numOfAttachementsNameKeyCreator = (params) => {
        var data = params.data;
        return data.NumOfAttachements;
    };
    const assetNameKeyCreator = (params) => {
        var data = params.data;
        return data.AssetName;
    };
    const dateKeyCreator = (params) => {
        var data = params.data;
        return moment(data.ActivityDate).format("MM/DD/YYYY");
    };
    const activityTypeNameKeyCreator = (params) => {
        var data = params.data;
        return data.ActivityType;
    };
    const subjectNameKeyCreator = (params) => {
        var data = params.data;
        return data.ActivityName;
    };
    const createdNameKeyCreator = (params) => {
        var data = params.data;
        return data.CreatedByName;
    };

    const ActionsRenderer = (event) => {
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable])
        return (
            <div className="actions-cell">
                <i onClick={(e) => { isEdit && onEditButtonClick(event) }}
                    className="fas fa-edit" style={{ color: isEdit === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}></i>

                <i onClick={(e) => { isEdit && initiateDetailsdelete(event) }}
                    className="fa fa-trash"
                    style={{ color: isEdit === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }}
                ></i>
            </div>
        );
    };

    const columnDefs = [
        {
            field: "NumOfAttachements",
            headerName: "No Of Attachments",
            maxWidth: 50,
            //filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: numOfAttachementsNameKeyCreator,
                convertValuesToStrings: true,
            },
            headerComponentParams: {
                template: '<i class="fa-solid fa-paperclip" style="color: #3C5F7A; font-size: 1.2rem;"></i>',
            },

        },
        {
            field: "AssetName",
            headerName: "Asset",
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: assetNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'AssetName'
        },
        {
            field: "Portfolios",
            headerName: "Portfolios",
            filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Portfolios'
        },
        {
            field: "Substrategies",
            headerName: "Sub Strategies",
            //  filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Substrategies'
        },
        {
            field: "Managers",
            headerName: "Managers",
            filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Managers'
        },
        {
            field: "Contacts",
            headerName: "Contacts",
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Contacts'
        },
        {
            field: "Contributors",
            headerName: "Contributors",
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Contributors'
        },
        {
            field: "ActivityDate",
            headerName: "Date",
            maxWidth: 130,
            //  filter: "agSetColumnFilter",
            valueFormatter: (params) => {
                return moment(params.value).format("MM/DD/YYYY");
            },
            filterParams: {
                keyCreator: dateKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityDate'
        },
        {
            field: "ActivityType",
            headerName: "Type",
            maxWidth: 150,
            //  filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: activityTypeNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityType'
        },
        {
            field: "ActivitySubType",
            headerName: "ActivitySubType",
            maxWidth: 130,
            //  filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'ActivitySubType'
        },
        {
            field: "ActivityName",
            headerName: "Subject",
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: subjectNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityName'
        },
        {
            field: "IsQuarterlyLetter",
            headerName: "Is Partner Letter",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            filterParams: {
                filterDefault: false,
            },
            tooltipField: 'IsQuarterlyLetter'
        },
        {
            field: "IsMarketCommentary",
            headerName: "Is Manager Letter",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            filterParams: {
                filterDefault: false,
            },
            tooltipField: 'IsMarketCommentary'
        },
        {
            field: "CreatedByName",
            headerName: "Created by",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: createdNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'CreatedByName'
        },
        {
            field: "CreatedDate",
            headerName: "Created Date",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: (params) => {
                return moment(params.value).format("MM/DD/YYYY");
            },
            tooltipField: 'CreatedDate'
        },
        {
            field: "Action",
            headerName: "Action",
            cellRenderer: ActionsRenderer,
            filter: false,
            maxWidth: 130,
        },
    ];
    const [colDef, setColDef] = useState([])
    const [appliedFilter, setAppliedFilter] = useState({})

    const defaultColDef = useMemo(() => { 
        return {
            flex: 1,
            minWidth: 100,
            resizable: true,
            enableValue: true,
            enableRowGroup: true,
            sortable: true,
            filter: true,
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            autoHeaderHeight: true
        };
    }, []);
    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}4` });
            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const filterOptions = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    cellRenderer: item.colId === "Action" ? ActionsRenderer : item.colId === "IsMarketCommentary" ? checkBoxFormatter : item.colId === "IsQuarterlyLetter" ? checkBoxFormatter : item.colId === "ActivityDate" ? valuformaterapply : item.colId === "CreatedDate" ? valuformaterapply : null,
                    "tooltipField": item.colId === "AssetName" ? "AssetName" : item.colId === "Portfolios" ? "Portfolios" :
                        item.colId === "Substrategies" ? "Substrategies" : item.colId === "Managers" ? "Managers" :
                        item.colId === "Contacts" ? "Contacts" : item.colId === "Contributors" ? "Contributors" :
                        item.colId === "ActivityType" ? "ActivityType" : item.colId === "ActivitySubType" ? "ActivitySubType" :
                        item.colId === "ActivityName" ? "ActivityName" : item.colId === "CreatedByName" ? "CreatedByName" : null
                               
                }));
                return { columns: formattedDef, filters: filterOptions };
            }
        } catch (error) {
            console.log(error);
            throw error; // Re-throw the error to handle it elsewhere if needed
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };


    useEffect(() => {
        document.title = `Investment`;
        fetchGridData();
    }, []);

    useEffect(() => {
        dispatch(getAssestListddlAction());
        dispatch(getCategory(1));
        dispatch(getActivityType());
        dispatch(getActivityEntityType(1));
        dispatch(getAllUsers());
        const EntityTypeId = EntityTypeIds?.map(
            (EntityTypes) => EntityTypes.ActivityEntityTypeId
        );
        const ActivityId = ActivityTypeIds?.map(
            (ActivityTypes) => ActivityTypes.ActivityTypeId
        );
        const CategoryId = ActivitySubTypeIds?.map(
            (ActivitySubTypes) => ActivitySubTypes.ActivitySubTypeId
        );
        dispatch(
            getActivitiesDetails(
                1,
                EntityTypeIds?.length === 4 || 0 ? -1 : EntityTypeId?.join(","),
                EntityId != null ? EntityId : "",
                ActivityTypeIds?.length === 5 || 0 ? -1 : ActivityId?.join(","),
                StartDate.toISOString(),
                EndDate.toISOString(),
                ActivitySubTypeIds==undefined?-1:ActivitySubTypeIds.length === 47 || 0 ? -1 : CategoryId?.join(","),
                Subject != null ? Subject : "",
                UserId != null ? UserId : "",
            )
        );
        setShowPreview(false);
    }, [render]);
    useEffect(() => {
        setEntityTypeIds(locationData.state !== null ? locationData.state.Type === null ? ActivityentityType : locationData.state.Type : ActivityentityType);
        setActivityTypeIds(locationData.state !== null ? locationData.state.Activity === null ? ActivityType : locationData.state.Activity : ActivityType);
        setActivitySubTypeIds(locationData.state !== null ? locationData.state.Category === null ? Category : locationData.state.Category : Category);
        setActivitySelected({ value: ActivityType, allSelected: true });
        setTypeSelected({ value: ActivityentityType, allSelected: true });
        setCategorySelected({ value: Category, allSelected: true })
    }, [ActivityType]);
    useEffect(() => {
        activities && setLoading(false);
    }, [activities]);
    useEffect(() => {
        setSelectedRowDocuList(Documents);
    }, [Documents])

    // Activity Multiselect Onchange...
    const activityTypeDDChange = (e) => {
 
        const currentSelectAll = ActivityTypeIds?.some((i) => i.ActivityType.trim() === "All") || false;
        const nextSelectAll = e.value.some((i) => i.ActivityType.trim() === "All");
        let value = e.value;
        const currentCount = ActivityTypeIds.length;
        const nextCount = value.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            ActivityType.length - 1 === nextCount
        ) {
            value = ActivityType;
        } else if (
            nextCount < currentCount &&
            currentCount === ActivityType.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ActivityType.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = ActivityType;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setActivitySelected({ value });
        setActivityTypeIds(value);
    };

    // Category Multiselect Onchange...
    const CategoryDDChange = (e) => {

        const currentSelectAll = categoryselected.value.some((i) => i.ActivitySubType.trim() === "All");
        const nextSelectAll = e.value.some((i) => i.ActivitySubType.trim() === "All");
        let value = e.value;
        const currentCount = categoryselected.value.length;
        const nextCount = value.length;
        if(nextSelectAll){
            value=Category;
        }
        else if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            Category.length - 1 === nextCount
        ) {
            value = Category;
        } else if (
            nextCount < currentCount &&
            currentCount === Category.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ActivitySubType.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = Category;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setCategorySelected({ value });
        setActivitySubTypeIds(value);
    };
    // Type Multiselect Onchange...
    const activityEntityTypeDDChange = (e) => {
        const currentSelectAll = EntityTypeIds?.some((i) => i.ActivityEntityType.trim() === "All");
        const nextSelectAll = e.value.some((i) => i.ActivityEntityType.trim() === "All");
        let value = e.value;
        const currentCount = typeselected.value.length;
        const nextCount = value.length;

        if (
            nextCount > currentCount &&
            !currentSelectAll &&
            !nextSelectAll &&
            ActivityentityType.length - 1 === nextCount
        ) {
            value = ActivityentityType;
        } else if (
            nextCount < currentCount &&
            currentCount === ActivityentityType.length &&
            currentSelectAll &&
            nextSelectAll
        ) {
            value = value.filter((v) => v.ActivityEntityType.trim() !== "All");
        } else if (!currentSelectAll && nextSelectAll) {
            value = ActivityentityType;
        } else if (currentSelectAll && !nextSelectAll) {
            value = [];
        }
        setTypeSelected({value});
        setEntityTypeIds(value);
    };
    const NamesOnChange = (e) => {
        const EntityTypeStr = EntityTypeIds.map(item => item.ActivityEntityTypeId).join(',');
        const SearchTerm = e.filter.value;
        if (SearchTerm.length > 2)
            dispatch(getActivityEntities(EntityTypeStr, SearchTerm, 1));
    }
    const handleLinkClick = (row) => {
        const ActivityId = row.data.ActivityId;
        if(ActivityId!=0)
        {
            dispatch(getMultipleDocs(ActivityId));
        }
        dispatch(getAssetNoteDetails(ActivityId));
        setDocumentCount(row.data.NumOfAttachements);
        setShowPreview(true);
    };
    const CreatoronChange = (e) => {
        SetUserId(e.value.UserId)
        setSelectedUser(e.value);
    }

    const customRanges = [
        {
            label: 'Last 30 Days',
            value: [new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
            new Date(),],
        },

        {
            label: 'Last 90 Days',
            value: [
                new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000),
                new Date(),
            ],
        },
        {
            label: 'YTD',
            value: [
                new Date(new Date().getFullYear(), 0, 1),
                new Date(),
            ],
        },

    ];
    const Preview = ({docCount}) => {

        const pdfview = (documentId, documentExtension,documentName) => {

            try {
                documentExtension=documentExtension.toLowerCase();
                if ( 
                documentExtension === ".pdf" ||
                documentExtension === ".xlsx" ||
                documentExtension === ".xls" ||
                documentExtension === ".png" ||
                documentExtension === ".jpg" ||
                documentExtension === ".jpeg" ||
                documentExtension === ".gif" ||
                documentExtension === ".doc" ||
                documentExtension === ".docx" || 
                documentExtension === ".ppt" || 
                documentExtension === ".pptx" ||

                documentExtension === "pdf" ||
                documentExtension === "xlsx" ||
                documentExtension === "xls" ||
                documentExtension === "png" ||
                documentExtension === "jpg" ||
                documentExtension === "jpeg" ||
                documentExtension === "gif" ||
                documentExtension === "doc" ||
                documentExtension === "docx" || 
                documentExtension === "ppt" || 
                documentExtension === "pptx"
            ){
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                    //     responseType: 'blob'
                }).then((response) => {
                    window.open(urls);

                });
            }

            else {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                     url: urls,
                     responseType: 'blob'
                 }).then((response) => {
                    const blob = new Blob([response]);
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${documentName}.${documentExtension}` 
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
              
             });
            }
                // if (documentExtension === ".pdf") {
                  
                //     //sbaAxios({
                //     //    url: DownloadDocument + documentId,
                //     //    responseType: 'blob',
                //     //}).then((response) => {
                //     //    window.open(URL.createObjectURL(response), "_blank");
                //     //});

                // } else if (
                //     documentExtension === ".xlsx" ||
                //     documentExtension === ".xls"
                // ) {
                //     const encodedDocumentId = btoa(documentId.toString());
                //     const urls = DownloadDocument + encodedDocumentId;
                //     sbaAxios({
                //         url: urls,
                //         //     responseType: 'blob'
                //     }).then((response) => {
                //         window.open(urls);

                //     });
                //     //sbaAxios({
                //     //    url: DownloadDocument + documentId,
                //     //    responseType: 'blob'
                //     //}).then((response) => {
                //     //    window.open(URL.createObjectURL(response), "_blank");
                //     //});

                // } else if (
                //     documentExtension === ".png" ||
                //     documentExtension === ".jpg" ||
                //     documentExtension === ".jpeg" ||
                //     documentExtension === ".gif"
                // ) {
                //     const encodedDocumentId = btoa(documentId.toString());
                //     const urls = DownloadDocument + encodedDocumentId;
                //     sbaAxios({
                //         url: urls,
                //         //     responseType: 'blob'
                //     }).then((response) => {
                //         window.open(urls);

                //     });
                //     //sbaAxios({
                //     //    url: DownloadDocument + documentId,
                //     //    responseType: 'blob'
                //     //}).then((response) => {
                //     //    window.open(URL.createObjectURL(response), "_blank");
                //     //});

                // }
                // else if (
                //     documentExtension === ".doc" || documentExtension === ".docx"
                // ) {
                //     const encodedDocumentId = btoa(documentId.toString());
                //     const urls = DownloadDocument + encodedDocumentId;
                //     sbaAxios({
                //         url: urls,
                //         //     responseType: 'blob'
                //     }).then((response) => {
                //         window.open(urls);

                //     });
                //     //sbaAxios({
                //     //    url: DownloadDocument + documentId,
                //     //    responseType: 'blob'
                //     //}).then((response) => {
                //     //    window.open(URL.createObjectURL(response), "_blank");
                //     //});

                // }
                // else if (
                //     documentExtension === ".ppt" || documentExtension === ".pptx"
                // ) {
                //     const encodedDocumentId = btoa(documentId.toString());
                //     const urls = DownloadDocument + encodedDocumentId;
                //     sbaAxios({
                //         url: urls,
                //         //     responseType: 'blob'
                //     }).then((response) => {
                //         window.open(urls);

                //     });
                //     //sbaAxios({
                //     //    url: DownloadDocument + documentId,
                //     //    responseType: 'blob'
                //     //}).then((response) => {
                //     //    window.open(URL.createObjectURL(response), "_blank");
                //     //});

                // }
            } catch (error) {
                console.error("Error opening document:", error);
            }
        };

        const noteDetails = useSelector(
            (state) => state.notesTabDetails.noteDetails
        );
        const noteDate = moment(noteDetails?.ActivityDate).format("MM-DD-YYYY");
        if (activities.length > 0) {
            if (Documents.length > 0 || noteDetails != null) {
                return (
                    <div id="InvestmentId">
                       {DocumentsLoading ? <><LoadingScreen/></> :
                            showPreview && <>
                                <div class="attachments bg-white p-3 mt-3">

                                    <form action="#">
                                        <ul class="list-unstyled m-0">
                                            <li class="fw-medium mb-3">
                                                Attachment{" "}
                                                <span class="notify ms-2">
                                                    {docCount ? docCount : 0}
                                                </span>
                                            </li>
                                        </ul>
                                    </form>

                                    {Documents?.length === 0 ? (
                                        <label>No Documents Available </label>
                                    ) : (
                                        Documents?.map((item) => {
                                            item.DocumentExtension  = item.DocumentExtension.toLowerCase();

                                            return (
                                                <div class="card-body p-0">
                                                    <div class="row p-3 border-bottom  m-0">
                                                        <div class="col-11 left">
                                                            <span>{item.DocumentName}</span>
                                                        </div>
                                                        {
                                                            <div class="col-1 text-sm-end fw-medium">
                                                                <span className="SBA_hand">
                                                                    {item.DocumentExtension === ".pdf" || item.DocumentExtension === "pdf"   ? (
                                                                        <i
                                                                            class="fas fa-file-pdf"
                                                                            style={{ color: "#F40F02" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    ) : item.DocumentExtension === ".xlsx" ||
                                                                        item.DocumentExtension === ".xls" || item.DocumentExtension === "xls" || item.DocumentExtension === "xlsx" ? (
                                                                        <i
                                                                            class="fas fa-file-excel"
                                                                            style={{ color: "#1D6F42" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    ) : item.DocumentExtension === ".png" || item.DocumentExtension === "png" ||
                                                                        item.DocumentExtension === ".jpg" || item.DocumentExtension === "jpg" ||
                                                                        item.DocumentExtension === ".jpeg" ||item.DocumentExtension === "jpeg" ||
                                                                        item.DocumentExtension === ".gif" || item.DocumentExtension === "gif"  ? (
                                                                        <i
                                                                            class="fas fa-file-image"
                                                                            style={{ color: "#1E3050" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    ) :
                                                                        item.DocumentExtension === ".doc" ||
                                                                            item.DocumentExtension === ".docx" ? (
                                                                            <i
                                                                                class="fas fa-file-word"
                                                                                style={{ color: "#2284D9" }}
                                                                                onClick={() =>
                                                                                    pdfview(
                                                                                        item.DocumentId,
                                                                                        item.DocumentExtension
                                                                                    )
                                                                                }
                                                                            ></i>
                                                                        ) : item.DocumentExtension === ".ppt" || item.DocumentExtension === "ppt" ||
                                                                            item.DocumentExtension === ".pptx" || item.DocumentExtension === "ppt" ? (
                                                                            <i
                                                                                class="fas fa-file-powerpoint"
                                                                                style={{ color: "#C13B1B" }}
                                                                                onClick={() =>
                                                                                    pdfview(
                                                                                        item.DocumentId,
                                                                                        item.DocumentExtension
                                                                                    )
                                                                                }
                                                                            ></i>
                                                                        ) : (
                                                                            <i
                                                                            class="fa-solid fa-file"
                                                                            style={{ color: "#C13B1B" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension,
                                                                                    item.DocumentName
                                                                                )
                                                                            }
                                                                        ></i>
                                                                        )}
                                                                </span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                                <div className="col-sm-12" style={{ height: "16px" }}></div>
                                <div class="investors bg-white p-3">
                                    <div className="row my-2 mt-4">
                                        <div className="col-md-4">
                                            <div className="fw-medium">Created By :</div>
                                            <div className="fw-medium">{noteDetails?.ActivitySource}</div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="fw-medium">Date Created :</div>
                                            <div className="fw-medium">{noteDate}</div>
                                        </div>
                                    </div>
                                    <div className="fw-medium">Subject :</div>
                                    <div className="fw-medium mb-2">{noteDetails?.ActivityName}</div>
                                    <div className="fw-medium ">Body :</div>
                                    <div >
                                        <iframe
                                            title="my-iframe"
                                            width="100%"
                                            height="400px"
                                            src={decodeHTMLEntities(noteDetails?.ActivityDescriptionHTML)}
                                        ></iframe>
                                    </div>
                                </div></>}
                    </div>
                );
            }
        }
    };
    const decodeHTMLEntities = (encodedString) => {
        const encodedHtmlContent = encodeURIComponent(encodedString);
        const src = `data:text/html;charset=utf-8,${encodedHtmlContent}`;
        if (encodedString == undefined)
            return "";
        return src;
    };
    const onAddButtonClick = (e) => {
        history(`${UrlPath.DocumentsInvestmentAdd}`, { state: { Type: EntityTypeIds, Names: selectedEntity, Activity: ActivityTypeIds, Category: ActivitySubTypeIds, Subject: Subject, Creator: selectedUser } });
    };
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current?.api.getToolPanelInstance('filters').expandFilters();
    }, []);

    const sideBar = {
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnFilter: true,
                    suppressColumnSelectAll: true,
                    suppressColumnExpandAll: true,
                },
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ],
        defaultToolPanel: null,
    };
    const DownloadZip = () => {

        const selectedNodes = documentListRef.current.api.getSelectedNodes();

        if (selectedNodes.length > 0) {

            const documentIDs = selectedRowDocuList.map(item => item.DocumentId).join(',') || null;

            if (documentIDs !== null) {

                try {

                    const downloadUrl = `${DownloadMultiDocument}${documentIDs}`;
                    sbaAxios({ url: downloadUrl, responseType: 'blob' }).then((response) => {
                        window.open(URL.createObjectURL(response, "_blank"));
                    });

                } catch (error) {
                    console.error('Error downloading documents:', error);

                }
            }
        }
    };
    const gridOptions = {
       
        autoGroupColumnDef: {
            minWidth: 200,
        },
        sideBar: sideBar,
    }
   
    const isRowSelectable = useMemo(() => {
        return (params) => {
            return !!params.data && params.data.NumOfAttachements > 0;
        };
    }, []);

    const handleDateChange = (e) => {
        const newStartDate = e.value.start !== null ? e.value.start : StartDate;
        const newEndDate = e.value.end !== null ? e.value.end : EndDate;
        setDateRange([newStartDate, newEndDate])
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    const subjectChange = (event) => {
        setSubject(event.target.value);
    };
    const enterbtnClick = () => {
        console.log("Before setting values: StartDate", StartDate, "EndDate", EndDate);

        if (StartDate === undefined && EndDate === undefined) {
            setStartDate(new Date());
            setEndDate(new Date());
        }
        const EntityTypeId = EntityTypeIds?.map(
            (EntityTypes) => EntityTypes.ActivityEntityTypeId
        ) || [];
        const ActivityId = ActivityTypeIds?.map(
            (ActivityTypes) => ActivityTypes.ActivityTypeId
        ) || [];

        const CategoryId = ActivitySubTypeIds?.map(
            (ActivitySubTypes) => ActivitySubTypes.ActivitySubTypeId
        ) || [];

        setShowPreview(false);
        const apiPostEntityTypeID= (EntityTypeIds?.length === 0  || !EntityTypeIds || ActivityentityType.length=== EntityTypeIds?.length) ? -1 : EntityTypeId.join(',');
        dispatch(
            getActivitiesDetails(
                1,
                apiPostEntityTypeID,
                EntityId != null ? EntityId : "",
                ActivityTypeIds?.length === 5 ? -1 : ActivityId?.join(","),
                StartDate.toISOString(),
                EndDate.toISOString(), 
                ActivitySubTypeIds==undefined?-1:ActivitySubTypeIds?.length === 47 ? -1 : CategoryId?.join(","),
                Subject != null ? Subject : "",
                UserId != null ? UserId : "",
            )
        );
        // dispatch(getMultipleDocs(0));
        dispatch(getAssetNoteDetails(-1));
        fetchGridData();
    };
    const ClearbtnClick = () => {
        setSubject(null);
        setEntityTypeIds([]);
        setActivityTypeIds([]);
        setSelectedEntity([]);
        setEndDate(new Date());
        setStartDate(oneMonthAgo);
        setSelectedUser({ UserId: "-1", Fullname: "Please Select" });
        setActivitySubTypeIds([]);
        setEntityId(null);
        SetUserId(null);
        setShowPreview(false);
        setInvestmentData([]);

        //setRender(value => value + 1);
    };
    const activityEntitesChanged = (e) => {
        setSelectedEntity(e.value);
        setEntityId(e.value ? e.value.EntityId : null);
        // if (StartDate === null && EndDate === null) {
        //     setStartDate(new Date());
        //     setEndDate(new Date());
        // }
        // const EntityTypeId = EntityTypeIds.map(
        //     (EntityTypes) => EntityTypes.ActivityEntityTypeId
        // );
        // const ActivityId = ActivityTypeIds.map(
        //     (ActivityTypes) => ActivityTypes.ActivityTypeId
        // );
        // const CategoryId = ActivitySubTypeIds.map(
        //     (ActivitySubTypes) => ActivitySubTypes.ActivitySubTypeId
        // );
        // dispatch(
        //     getActivitiesDetails(
        //         1,
        //         EntityTypeIds.length == 4 ? "" : EntityTypeId.join(","),
        //         e.value != null ? e.value.EntityId : "",
        //         ActivityTypeIds.length == 5 ? "" : ActivityId.join(","),
        //         StartDate.toISOString(),
        //         EndDate.toISOString(),
        //         ActivitySubTypeIds.length == 46 ? "" : CategoryId.join(","),
        //         Subject!=null ? Subject:"",
        //         UserId != null ? UserId : "",
        //     )
        // );
    };
    const investmentSplitterState=localStorage.getItem('DocuInvestmentSplitter');
    const [panes, setPanes] = React.useState(investmentSplitterState ? JSON.parse(investmentSplitterState) : [{
        size: '70%',
        min: '20px',
        collapsible: true
    }, {}, {
        size: '20%',
        min: '20px',
        collapsible: true
    }]);
    const onChange = event => {
        localStorage.setItem("DocuInvestmentSplitter",JSON.stringify(event.newState));
        setPanes(event.newState);

    };
    const loadOnEnter = (event) => {
        if (event.key === 'Enter') {
            enterbtnClick()
        }
    };
    const deleteSelectedDetails = () => {
        sbaAxios({ url: `${deleteActivity}${idToDelete}` }).then(res => {
            SBNotify({ Msg: "Selected Document Deleted Successfully", type: "success" });
            setShowModal(false);
            enterbtnClick();
            setShowPreview(false);
        }).catch(error => {
            SBNotify({ Msg: error, type: "error" });
            setShowModal(false)
        })
    };
    if(!investmentAccess)
    {
        return<>
        {!accessLoading ? 
        <> <TopBar label={"Investment"} />
    <div id="assetList" className="mainContentData"><Unauthorized/></div></>:<><LoadingScreen/></>}
        </>
    }
    return (
        <>
            <div>
                <TopBar label={"Investment"} />
             
                <BreadCrumbs Levels={Level} />

               
                    <div className="bg-white m-4 mb-3 p-3 border rounded">
                        <form action="#">
                            <div className="row border-bottom pb-3">
                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fw-semibold fs-12"
                                    >
                                        Type
                                    </label>
                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            data={ActivityentityType}
                                            value={
                                                EntityTypeIds
                                            }
                                            dataItemKey="ActivityEntityTypeId"
                                            textField="ActivityEntityType"
                                            onChange={activityEntityTypeDDChange}
                                            tags={
                                                EntityTypeIds?.length > 0
                                                    ? [{ text: `${EntityTypeIds?.filter(item => item.ActivityEntityType.trim() !== "All").length} items selected`, data: [...EntityTypeIds] }]
                                                    : []
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fw-semibold fs-12 d-block"
                                    >
                                        Names
                                    </label>
                                    <SBAMultiColumnComboBox
                                        className="w-75"
                                        data={activityEntities}
                                        value={selectedEntity}
                                        columns={[{ field: "EntityName", header: "Name", width: '300px' }, { field: "ActivityEntityType", header: "Type", width: '100px' }]}
                                        filterable={true}
                                        textField="EntityName"
                                        valueField="EntityId"
                                        onFilterChange={NamesOnChange}
                                        onChange={activityEntitesChanged}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fw-semibold fs-12"
                                    >
                                        Activity
                                    </label>
                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            data={ActivityType}
                                            value={ActivityTypeIds}
                                            dataItemKey="ActivityTypeId"
                                            textField="ActivityType"
                                            onChange={activityTypeDDChange}
                                            tags={
                                                ActivityTypeIds?.length > 0
                                                    ? [{ text: `${ActivityTypeIds?.filter(item => item.ActivityType.trim() !== "All").length} items selected`, data: [...ActivityTypeIds] }]
                                                    : []
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <p className="fw-semibold mt-1">Filter by</p>
                            <div className="row" >
                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fw-semibold fs-12"
                                    >
                                        Date Range
                                    </label>
                                    <div style={{width:"70%"}}>
                                    <SBDateRangePicker
                                        value={{ start: dateRange[0], end: dateRange[1] }}
                                        onChange={(e) => { handleDateChange(e) }}

                                    />
                                    </div>

                                    {/*<DateRangePicker*/}
                                    {/*    className="SbaDateRage text-dark"*/}
                                    {/*    placeholder="Select Date Range"*/}
                                    {/*    value={[*/}
                                    {/*        StartDate ? moment(StartDate).toDate() : new Date(),*/}
                                    {/*        StartDate ? moment(EndDate).toDate() : new Date(),*/}
                                    {/*    ]}*/}
                                    {/*    format="MM/dd/yyyy"*/}
                                    {/*    onChange={handleDateChange}*/}
                                    {/*    block*/}
                                    {/*    character=" - "*/}
                                    {/*    ranges={customRanges}*/}
                                    {/*/>*/}
                                </div>
                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fw-semibold fs-12"
                                    >
                                        Category
                                    </label>
                                    <div>
                                        <SBAMultiSelectCheck
                                            className="w-75"
                                            data={Category}
                                            value={ActivitySubTypeIds}
                                            dataItemKey="ActivitySubTypeId"
                                            textField="ActivitySubType"

                                            onChange={CategoryDDChange}
                                            tags={
                                                ActivitySubTypeIds?.length > 0
                                                    ? [{ text: `${ActivitySubTypeIds?.filter(item => item?.ActivitySubType.trim() !== "All").length} items selected`, data: [...ActivitySubTypeIds] }]
                                                    : []
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fs-12 fw-semibold"
                                    >
                                        Subject
                                    </label>
                                    <input
                                        className="w-75 input-default form-control"
                                        type="text"
                                        placeholder="Type here"
                                        onChange={subjectChange}
                                        value={Subject ? Subject : ''}
                                        onKeyUp={loadOnEnter}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label
                                        for="select fund"
                                        className="mb-1 ms-2 fw-semibold  fs-12 d-block"
                                    >
                                        Creator
                                    </label>
                                    <SBADropDown
                                        className="w-75"
                                        textField={"Fullname"}
                                        valueField={"UserId"}
                                        data={users}
                                        value={selectedUser}
                                        onChange={CreatoronChange}
                                    />
                                </div>
                            </div>
                            <div className="mt-3">
                                <button
                                    type="button"
                                    className="enter-btn"
                                    onClick={enterbtnClick}
                                >
                                    Enter
                                </button>
                                <button type="button" className="cancel-btn ms-2" onClick={ClearbtnClick}>
                                    Clear All
                                </button>
                            </div>
                        </form>
                    </div>
                    <div>
                        <div className="mx-4 p-3">
                            <div className="row">
                                <Splitter orientation={'vertical'}>
                                    <Splitter panes={panes} onChange={onChange}>
                                        <div class="col-lg-12 col-md-12 bg-white  rounded">
                                            <div className="mt-3 d-flex justify-content-between" style={{ marginTop: "20px" }}>
                                                <p className="fw-semibold p-0 py-1">List of Details</p>

                                                <div className="d-flex justify-content-end gap-2">
                                                    <button type="submit" onClick={onAddButtonClick} className="p-sm-btn mx-1" disabled={!isEditable}><i className="fa-solid fa-plus" /> Add</button>
                                                    <button type="button" className="p-sm-btn mx-1" onClick={DownloadZip}><img src={download} alt="" />Download</button>
                                                </div>
                                            </div>
                                                    <SBGrid isLoading={activitesGridLoading} ref={documentListRef} column={colDef}  defaultColDef={defaultColDef} row={activities} pageSize={15} rowSelection="single" filters={appliedFilter} componentID={4} gridStyle={{ width: '100%', height: '750px' }}  onRowClicked={handleLinkClick}></SBGrid>
                                        </div>

                                        <div class="col-lg-12 mt-md-2 mt-lg-0">
                                            <div className="preview">
                                                <p className="fw-semibold py-3 px-3">Preview</p>
                                                <Preview docCount={DocumentCount}/>
                                            </div>
                                        </div>
                                    </Splitter>
                                </Splitter>
                            </div>
                        </div>
                    </div>
            </div>
            <Modal show={showModal}  >
                <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
                    <Modal.Title>Do you want to delete the selected Document?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Document will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setShowModal(false) }}>Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { deleteSelectedDetails() }} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </>
    );
};
